import { render } from "./richContent.vue?vue&type=template&id=0a619b7c"
import script from "./richContent.vue?vue&type=script&lang=js"
export * from "./richContent.vue?vue&type=script&lang=js"

import "./richContent.vue?vue&type=style&index=0&id=0a619b7c&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__